<div class="right-panel h-100">
  <div class="right-side">
    <as-split direction="horizontal">
      <as-split-area [size]="detailsViewOpen ? 20 : 100">
        <div class="user-list h-100 d-flex flex-column">
          <div class="actionBar mt-0">
            <div class="flex-grow-1 h-100">
              <input class="search float-start"
                     type="text"
                     placeholder="Search by Name or Tag"
                     [formControl]="searchTerm" />
            </div>
            <button
                    type="button"
                    class="actionBtn"
                    (click)="refreshComponent()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="Refresh Users"
                    >
              <span class="bi bi-arrow-clockwise"></span>
            </button>
            @if(!detailsViewOpen){
            <button
                    type="button"
                    class="actionBtn"
                    (click)="editColoum()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="Add/Remove columns from table"
                    >
              <span><i class="bi bi-sliders"></i></span>
            </button>
            @if(!isJobOperator){
            <button
            type="button"
            class="actionBtn position-relative"
            [ngbPopover]="userFilterContent"
            #userFilterPopover="ngbPopover"
            [autoClose]="'outside'"
            popoverClass="filter-popover"
            container="body"
            placement="bottom"
            (mouseenter)="tooltipInstance.open()"
            (mouseleave)="tooltipInstance.close()"
            [ngbTooltip]="'Show/Hide Filters'"
            #tooltipInstance="ngbTooltip"
          >
            <span class="bi bi-funnel"></span>
            <span
              class="position-absolute top-0 start-100 badge rounded-pill"
              *ngIf="getActiveFiltersCount() > 0"
            >
              {{ getActiveFiltersCount() }}
              <span class="visually-hidden">active filters</span>
            </span>
          </button>
            <button
                    class="actionBtn"
                    (click)="getBillingInput()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="View consumption"
                    >
              <span><i class="bi bi-receipt"></i></span>
            </button>
            <button *ngIf="isMonitor == false"
                    class="actionBtn"
                    (click)="addBulkUser()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="Import users"
                    >
              <span><i class="bi bi-person-up"></i></span>
            </button>
            <button
                    class="actionBtn"
                    (click)="downloadDataAsCsv()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="Download user data as CSV"
                    >
              <span><i class="bi bi-person-down"></i></span>
            </button>
            <button *ngIf="isMonitor == false"
                    class="actionBtn"
                    (click)="deleteUsers()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="Delete users"
                    >
              <span><i class="bi bi-person-x"></i></span>
            </button>
            <button *ngIf="isMonitor == false"
                    class="actionBtn"
                    (click)="addUser()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="Add new user"
                    >
              <span><i class="bi bi-person-fill-add"></i></span>
            </button>
            } }
          </div>
          <ng-template #userFilterContent>
            <div class="filter-container text-grey">
              <!-- Deployment Filter -->
              <form [formGroup]="filterForm">
                <div class="filter-section">
                  <label>Deployment</label>
                  <div class="field-container">
                    <ng-select class="text-grey"
                               [items]="deployments"
                               bindLabel="name"
                               bindValue="name"
                               formControlName="deployment"
                               [clearable]="false"
                               [searchable]="true">
                      <ng-option value="All">All Deployments</ng-option>
                      <ng-option *ngIf="deploymentFilterShow" value="Unassigned">Unassigned</ng-option>
                    </ng-select>
                  </div>
                </div>

                <!-- User Role Filter -->
                <div class="filter-section">
                  <label>User Role</label>
                  <div class="field-container">
                    <ng-select class="text-grey"
                               [items]="userRoleFilterOptions"
                               bindLabel="key"
                               bindValue="value"
                               formControlName="userRole"
                               [clearable]="false"
                               [searchable]="false">
                    </ng-select>
                  </div>
                </div>

                <!-- Allocated Cores Filter -->
                <div class="filter-section">
                  <label>Allocated Cores</label>
                  <div class="field-container">
                    <ng-select formControlName="allocatedCores"
                               [clearable]="false"
                               [searchable]="false">
                      <ng-option value="All">All Cores</ng-option>
                      <ng-option *ngFor="let cores of allocatedCoresList" [value]="cores">
                        {{ cores == -1 ? "Unlimited" : cores }}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <!-- Workstation Filter -->
                <div class="filter-section">
                  <label>Workstation</label>
                  <div class="field-container">
                    <ng-select formControlName="machine"
                               [clearable]="false"
                               [searchable]="false">
                      <ng-option value="All">All Workstations</ng-option>
                      <ng-option *ngFor="let ws of mapped" [value]="ws">
                        {{ ws }}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <!-- Reset Button -->
                <div class="d-flex justify-content-end">
                  <button type="button" class="reset-button" (click)="resetFilter()">
                    <svg class="reset-icon"
                         xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor">
                      <path stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                    </svg>
                    Reset Filters
                  </button>
                </div>
              </form>
            </div>
          </ng-template>
          @if(filterUser?.length > 0){
          <div class="listTable overflow-auto" style="white-space: nowrap">
            <div class="flex-grow-1">
              <table
                     class="table table-hover table-condensed"
                     [ngClass]="{ 'minW-90': detailsViewOpen }"
                     cellspacing="0"
                     id="jobInfoListID"
                     style="border-collapse: collapse"
                     dynamicPagination
                     [rowHeight]="32"
                     [offsetHeight]="180"
                     [paginationInstance]="config"
                     >
                <thead>
                  <tr class="table-list-head">
                    <th
                        class="selectAllCheckBox"
                        title="Select All"
                        resizable
                        (change)="onSelectAllCheckBox($event)"
                        >
                      <input type="checkbox" [checked]="isSelectAll" id="" />
                    </th>
                    <th scope="col" resizable>
                      <a
                         style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        "
                         >#</a
>
                    </th>
                    <th scope="col" resizable>
                      <a
                         style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        "
                         >User Name</a
>
                    </th>
                    <th
                        scope="col"
                        resizable
                        *ngIf="editedColumnList.includes('First Name')"
                        >
                      <a
                         style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        "
                         >First Name</a
>
                    </th>
                    <th
                        scope="col"
                        resizable
                        *ngIf="editedColumnList.includes('Last Name')"
                        >
                      <a
                         style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        "
                         >Last Name</a
>
                    </th>
                    <th
                        scope="col"
                        resizable
                        *ngIf="editedColumnList.includes('Email Id')"
                        >
                      <a
                         style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        "
                         >Email Id</a
>
                    </th>
                    <th>Access</th>
                    <th scope="col" width="25%">
                      <a
                         style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        "
                         >Attached Group</a
>
                    </th>
                    <th
                        scope="col"
                        *ngIf="editedColumnList.includes('User Role')"
                        resizable
                        >
                      <a
                         style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        "
                         >User Role</a
>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-list-row"
                      style="cursor: pointer"
                      (click)="redirectTo(user, i)"
                      [ngClass]="{
                      highlightClickedRow:
                        selectedUser?.userName == user.userName
                    }"
                      (dblclick)="toggleDetailsView(user)"
                      *ngFor="
                      let user of filterUser
                        | paginate
                          : { itemsPerPage: config.itemsPerPage, currentPage: config.currentPage };
                      let i = index
                    "
                      >
                    <td>
                      <div>
                        <input
                               type="checkbox"
                               title="Select Node"
                               class="selectCheckbox"
                               (click)="
                            checkSelectedCheckboxes($event, user.userName)
                          "
                               [checked]="multiSelectIndex.includes(user.userName)"
                               />
                      </div>
                    </td>
                    <td style="cursor: pointer" scope="row">
                      {{ config.currentPage == 1 ? i + 1 : (config.currentPage - 1) * config.itemsPerPage + (i + 1) }}
                    </td>
                    <td class="impListName" (click)="toggleDetailsView(user)" [attr.id]="user.userName+'-toggleDetailsView'">
                      {{ user.userName }}
                      @if(user.userName === this.authenticationService.currentUserValue.username) {
                      <span class="live-indicator ms-2">YOU</span>
                      }
                    </td>
                    <td
                        class="impListName"
                        *ngIf="editedColumnList.includes('First Name')"
                        >
                      {{ user.firstName || "NA" }}
                    </td>
                    <td
                        class="impListName"
                        *ngIf="editedColumnList.includes('Last Name')"
                        >
                      {{ user.lastName || "NA" }}
                    </td>
                    <td
                        *ngIf="editedColumnList.includes('Email Id')"
                        style="cursor: pointer"
                        title="{{ user.emailId }}"
                        >
                      {{ user.emailId || "NA" | sliceEmail : 50 }}
                    </td>
                    <td class="">
                      <div ngbDropdown class="d-inline-block" placement="end-top" container="body">
                        <button
                                *ngIf="checkAccessToShow(user) == 'select'"
                                type="button"
                                class="btn borderedBtn accessButton"
                                id="dropdown1"
                                ngbDropdownToggle
                                style="font-size: 0.8rem; padding: 0.1rem 0.5rem;"
                                >
                          Deployment : Roles
                        </button>

                        <div ngbDropdownMenu aria-labelledby="dropdown1" class="p-0">
                          <mat-list class="p-0">
                            <mat-list-item ngbDropdownItem class="px-2" *ngFor="let dep of user.userDetails">
                              <span matListItemTitle>{{ dep.deploymentName }}</span>
                              <span matListItemLine class="ms-2">{{ getUserRole(dep.userRole) }}</span>
                            </mat-list-item>
                          </mat-list>
                        </div>
                      </div>
                      <span
                            *ngIf="checkAccessToShow(user) == 'Reader'"
                            ngbTooltip="Reader">
                        Reader
                      </span>
                      <span
                            *ngIf="checkAccessToShow(user) == 'GlobalAdmin'"
                            ngbTooltip="Global Admin">
                        Global Admin
                      </span>
                      <span *ngIf="checkAccessToShow(user) == 'NoContent'" class="ms-5">-</span>
                    </td>
                    <td
                        style="cursor: pointer"
                        title="{{ user.attachedGroup }}"
                        >
                      {{ user.attachedGroup }}
                    </td>
                    <td
                        style="cursor: pointer"
                        *ngIf="editedColumnList.includes('User Role')"
                        title="{{ user.userRole }}"
                        >
                      {{ user.userRole || "NA" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination-container d-flex my-1">
              <pagination-controls
                                   class="my-pagination"
                                   (pageChange)="config.currentPage = $event"
                                   autoHide="true"
                                   (pageBoundsCorrection)="config.currentPage = $event"
                                   ></pagination-controls>
            </div>
          </div>
          } @else {
          <ng-container *ngTemplateOutlet="noContent"></ng-container>
          }
        </div>
      </as-split-area>
      <as-split-area
        [size]="detailsViewOpen ? 80 : 0"
        *ngIf="detailsViewOpen"
        [minSize]="60"
      >
        <div class="h-100 mx-1 px-1 advanceDetails">
          <app-user-advance-view
            (hideDetails)="hideDetails()"
            (handleAction)="handleAction($event)"
          ></app-user-advance-view>
        </div>
      </as-split-area>
    </as-split>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="userList"
  >
    <p class="pleaseWait">Please wait ...</p>
  </ngx-spinner>
</div>

<ng-template #noContent>
  @if(!users || !filterUser){
  <!-- <p class="pt-5 text-center color-border">Loading...</p> -->
  } @else if(users.length == 0){
  <p class="pt-5 text-center">Users not found. Please add new user.</p>
  } @else if(filterUser.length == 0){
  <p class="pt-5 text-center">User not found</p>
  } @else {
  <p class="pt-5 text-center">Something went wrong!</p>
  }
</ng-template>
